import React, { useContext } from "react";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import SectionHeader from "../components/section/SectionHeader";
import InfoAlert from "../ui/InfoAlert";
import OrgContext from "../store/orgContext";
import InlineLoader from "../components/loader/InlineLoader";
import NewMCPTTGroup from "../components/mcpttGroups/NewMcpttGroups";
import {
  CREATE_MCPTT_GROUP_TRANSLATIONS,
  LOADING_TEXT_TRANSLATIONS,
} from "../translations/util";

const NewMCPTTGroups = () => {
  const { orgs: orgList, selectedOrg, updateOrg } = useContext(OrgContext);

  if (!orgList || orgList.length === 0) {
    return (
      <InlineLoader
        description={LOADING_TEXT_TRANSLATIONS.defaultLoadingText}
      />
    );
  }

  return (
    <>
      <SectionHeader
        pageTitle={CREATE_MCPTT_GROUP_TRANSLATIONS.header}
        pageDescription={CREATE_MCPTT_GROUP_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown
              disabled
              org={selectedOrg || undefined}
              orgsList={orgList}
              setOrg={updateOrg}
            />
          </div>
        }
      />

      <div className="main-content">
        {selectedOrg ? (
          <NewMCPTTGroup org={selectedOrg.id} />
        ) : (
          <InfoAlert
            heading={CREATE_MCPTT_GROUP_TRANSLATIONS.infoAlert.heading}
            subText={CREATE_MCPTT_GROUP_TRANSLATIONS.infoAlert.subText}
          />
        )}
      </div>
    </>
  );
};

export default NewMCPTTGroups;
